import React from "react";
import configData from "../../config.json"

function Stepper(prop) {
  return (
    <div className="text-center w-100">
      <div className={`col-12 w-100  step-${prop.step}`}>
        <img src={`../resources/${configData.COMPANY}/01-Banner-online-interno-${prop.step}A.png`} className="img-fluid w-100 mobile" alt="" />
        <img src={`../resources/${configData.COMPANY}/01-Banner-online-interno-${prop.step}A-mobile.png`} className="img-fluid w-100 d-md-none d-lg-none" alt="" />
      </div>
      <div className="col-12">
        <div className="row text-center mx-lg-5 my-lg-5">
          <div className="col">
            <span className={`badge rounded-pill w-100 ${prop.step == 1 ? `btn-green` : `bg-light`}`}> </span>
          </div>
          <div className="col">
            <span className={`badge rounded-pill w-100 ${prop.step == 2 ? `btn-green` : `bg-light`}`}> </span>
          </div>
          <div className="col">
            <span className={`badge rounded-pill w-100 ${prop.step == 3 ? `btn-green` : `bg-light`}`}> </span>
          </div>
          <div className="col">
            <span className={`badge rounded-pill w-100 ${prop.step == 4 ? `btn-green` : `bg-light`}`}> </span>
          </div>
          <div className="col">
            <span className={`badge rounded-pill w-100 ${prop.step == 5 ? `btn-green` : `bg-light`}`}> </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Stepper